import React, { useEffect } from 'react';
import { useLocalStorage } from 'react-use';

const useShowGraduateModal = ({ courseCode }) => {
  // skooldio_should_show_graduate_modal is a condition to show next round of graduate modal
  // default of skooldio_should_show_graduate_modal is `true` (Should show in first time)
  const [shouldShowGraduateModal, setShouldShowGraduateModal] = useLocalStorage(
    'skooldio_should_show_graduate_modal',
    {}
  );

  useEffect(() => {
    if (courseCode !== '' && courseCode !== undefined) {
      if (shouldShowGraduateModal[courseCode] === undefined) {
        setShouldShowGraduateModal({
          ...shouldShowGraduateModal,
          [courseCode]: true,
        });
      }
    }
  }, [courseCode]);

  const currentShouldShowGraduateModal = shouldShowGraduateModal[courseCode];

  const updateShouldShowGraduateModal = () => {
    setShouldShowGraduateModal({ ...shouldShowGraduateModal, [courseCode]: false });
  };

  return [currentShouldShowGraduateModal, updateShouldShowGraduateModal];
};

export default useShowGraduateModal;
